import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type QuoteRecord = NonNullable<
  ResultOf<typeof quoteRecordQuery>["quote"]
>;

export const quoteRecordQuery = graphql(`
  query QuoteRecord($id: ID!) {
    quote(id: $id) {
      ...QuoteRecordFields
      ...QuoteActionFields
    }
  }
`);

graphql(`
  fragment QuoteRecordFields on Quote {
    id
    reference
    currency
    quote_date
    expiry_date
    tax_inclusion_type
    additional_notations
    purchase_order_number
    declined_reason
    declined_reason_description

    amount_tax
    amount_exc_tax
    amount_inc_tax

    pdf_url

    payee {
      ...ContactRecordFields
    }

    lineItems {
      id
      unit_amount
      quantity
      tax_type
      description

      amount
      amount_inc_tax
      amount_exc_tax
      amount_tax
      created_at
      updated_at
    }
  }

  fragment QuoteActionFields on Quote {
    reference
    id
    status
    uuid
  }
`);
